module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_9005.075a373f.png";